import React, {useRef, useState} from "react";
import Carousel from "../baseComponents/gui/carousel/Carousel";
import PodcastsItem from "./PodcastsItem";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import Icon from "../baseComponents/gui/icon/Icon";
import classNames from "classnames";
import {settings} from "../../constants/carousel-settings";
import styles from "./Podcasts.module.scss";


const Podcasts = React.forwardRef(
  function Podcasts({list, className}, ref) {
    const [status, setStatus] = useState("start");
    const prevElRef = useRef();
    const nextElRef = useRef();
    const newList = [...list];


    return (
      <section className={classNames(styles.podcasts, className, {
        [styles[`podcasts_${status}`]]: status,
      })} ref={ref}>

        <div className={classNames(styles.podcasts__content, {})}>
          <Carousel
            item={PodcastsItem}
            itemsData={newList}
            settings={{
              ...settings.podcastsSetting,
              navigation: {
                prevEl: ".podcasts-btn-prev",
                nextEl: ".podcasts-btn-next",
              },
              pagination: {
                ...settings.podcastsSetting.pagination,
                el: ".podcasts__pagination",
              },
              onReachEnd: () => {
                setStatus("end")
              },
              onReachBeginning: () => {
                setStatus("start")
              },
              onSlideChange: ({isBeginning, isEnd}) => {
                if (!isBeginning && !isEnd) {
                  setStatus("")
                }
              }
            }
            }

          />
          <div className={classNames("podcasts__pagination",styles.podcasts__pagination)} />
          <div className={styles.podcasts__navigation}>
            <Button className={classNames(
              "podcasts-btn-prev",
              buttonStyles.button_white,
              buttonStyles.button_icon,
              styles.podcasts__navButton,
              styles.podcasts__navButton_prev,
            )}
                    ref={prevElRef}
                    aria-label={"назад"}
                    title={"назад"}
            >
              <Icon name={"prev"} width={56} height={56}/>
            </Button>
            <Button className={classNames(
              "podcasts-btn-next",
              buttonStyles.button_white,
              buttonStyles.button_icon,
              styles.podcasts__navButton,
              styles.podcasts__navButton_next,
            )}
                    ref={nextElRef}
                    aria-label={"вперед"}
                    title={"вперед"}
            >
              <Icon name={"next"} width={56} height={56}/>
            </Button>
          </div>
        </div>
      </section>
    );
  });
export default Podcasts;
Podcasts.propTypes = {};

